<template>
  <div class="back-to-site">
    <block-heading
      :selector="`back-to-site`"
      :title="options.backToSite.title"
      :text="options.backToSite.text"
    />
    <div class="back-to-site__buttons">
      <button-theme
        v-for="item in options.backToSite.btns"
        :key="item.id"
        :size="`s`"
        :mode="`transparent`"
        :width="229"
        :href="item.link"
        :name="item.name"
        :label="item.name"
        @handleClick="handleClick(item)"
      />
    </div>
  </div>
</template>

<script>
import blockHeading from './blockHeading.vue';
import buttonTheme from './buttonTheme.vue';

export default {
  name: 'popupBack',
  components: {
    blockHeading,
    buttonTheme,
  },
  computed: {
    options() {
      return this.$store.state.siteData;
    },
  },
  methods: {
    handleClick(item) {
      if (item.sure === 'no') {
        this.$emit('handleClick');
      }
    },
  },
};
</script>

<style lang="scss">
@import '../../../sass/setup.scss';

.back-to-site {
  padding: 87px 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow-y: auto;

  @include up-tablet {
    padding: 84px 30px;
  }

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
    background: rgba(227, 215, 203, 0.9);
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0;
    background: linear-gradient(180deg, #f7ece2, rgba(247, 235, 225, 0));
  }

  &__heading {
    margin-bottom: 4px;

    @include up-tablet {
      margin-bottom: 10px;
      max-width: 556px;
    }
  }

  &__text {
    margin-bottom: 29px;

    @include up-tablet {
      margin-bottom: 40px;
    }
  }

  &__buttons {
    margin: 20px auto 0;
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: repeat(2, auto);
    grid-row-gap: 10px;

    @include up-tablet {
      margin: 40px auto 0;
      grid-template-columns: repeat(2, 229px);
      grid-column-gap: 16px;
    }

    & > * {
      margin: auto;
      min-width: 229px;
    }
  }
}
</style>
